import { useState } from "react";
import { getMyServices } from "../../../utils";
import { useAppSelector } from "../../../redux/hooks/redux";
import { selectCurrentCompany } from "../../../redux/features/user/selectors/userState.selectors";

export const useServices = (type) => {
  const token = sessionStorage.getItem("token");
  const company = useAppSelector(selectCurrentCompany)
  const companyId = company?.id
  const [services, setServices] = useState();

  const getServices = async () => {
    const res = await getMyServices(type, token, companyId);
    let services = [];
    res.forEach((service) => {
      if (service?.companyServices?.some((cs) => cs.isActive)) {
        services.push(service);
      }
    });

    setServices(services);
  };

  return {
    getServices,
    services,
  };
};
